const normalizeString = (string: string) => string.toLowerCase().trim()

/**
 * Simple sorter to sort items by a match string, placing best-matches first.
 * Candidates that equal or start with the match are placed first.
 * Otherwise, localeCompare is used.
 *
 * Note that this does not match or filter out items. Items should already be matched and filtered out before using this sorter.
 * */
export function createMatchSorter<T>(match: string | null | undefined, iteratee: (item: T) => string) {
    return (a: T, b: T) => {
        const candidateA = normalizeString(iteratee(a))
        const candidateB = normalizeString(iteratee(b))
        if (candidateA === candidateB) return 0

        if (!match) {
            return candidateA.localeCompare(candidateB)
        }

        const normalizedMatch = normalizeString(match)

        if (candidateA === normalizedMatch) return -1
        if (candidateB === normalizedMatch) return 1

        const aStartsWith = candidateA.startsWith(normalizedMatch)
        const bStartsWith = candidateB.startsWith(normalizedMatch)
        if (aStartsWith && !bStartsWith) return -1
        if (!aStartsWith && bStartsWith) return 1

        return candidateA.localeCompare(candidateB)
    }
}
